/**
 * review-invalidation-alert.js
 */

import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import { Types } from 'utils/constants';
import { UserContext } from 'contexts/user/user-context';


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  }
}));


export default function ReviewInvalidationAlert(props) {
  const {
    review,
    ...rest
  } = props;
  const classes = useStyles();
  const { user } = React.useContext(UserContext);

  if (!user.role.isHandler || review?.status !== Types.ReviewStatus.ACCEPTED) return null;

  return (
    <>
      <Alert severity='error' className={classes.root} {...rest}>
        <Typography className='section'>
          This record was previously reviewed by your supervisor. If you save any changes the record will be set to <b>Not Reviewed</b> and your supervisor will need to review the record again.
        </Typography>
      </Alert>
    </>
  );
}